import { render, staticRenderFns } from "./Xisobot.vue?vue&type=template&id=e9b0707e"
import script from "./Xisobot.vue?vue&type=script&lang=js"
export * from "./Xisobot.vue?vue&type=script&lang=js"
import style1 from "./Xisobot.vue?vue&type=style&index=1&id=e9b0707e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports